const handleRetailFilter = (filterID, filterPlaceholder) => {
  const retailFilter = document.querySelector(
    `.filter-section-parametric-id-${filterID}`
  );
  if (retailFilter) {
    const filtersWrapper = document.querySelector("#filters");
    //filtersWrapper.prepend(retailFilter)
    retailFilter.setAttribute("custom-type", "retail-filter");

    const retailForm = retailFilter.querySelector("form");

    // VYHLEDAVACI POLE
    const inputField = document.createElement("input");
    inputField.type = "text";
    inputField.classList.add("custom-search");
    inputField.placeholder = filterPlaceholder;
    inputField.addEventListener("click", (e) => {
      e.stopPropagation();
      e.preventDefault();

    });
    const header = retailFilter.querySelector("h4");
    header.addEventListener("click", (e) => {
  inputField.focus();
    });
inputField.addEventListener("input", (e) => {
  const viableFields = retailForm.querySelectorAll(
    'input:not([type="hidden"])'
  );
  if (viableFields.length) {
    viableFields.forEach((field) => {
      if (
        !field.disabled && // doplněno: zkontroluj, zda není disabled
        field.value.toUpperCase().includes(inputField.value.toUpperCase())
      ) {
        field.parentElement.style.display = "block";
      } else {
        field.parentElement.style.display = "none";
      }
    });
  }
});

    retailForm.parentElement.insertBefore(inputField, retailForm);

    const isSomethingChecked = retailForm.querySelector("input:checked");
    if (isSomethingChecked) {
      const uncheckedFields = retailForm.querySelectorAll(
        'input:not([type="hidden"]):not([checked])'
      );
      uncheckedFields.forEach((field) => {
        field.parentElement.style.display = "none";
      });
    }

    const allInputs = retailForm.querySelectorAll('input:not([type="hidden"])');
    if (allInputs.length) {
      allInputs.forEach((input) => {
        input.addEventListener("click", (e) => {
          if (input.checked == true) {
            let selectedArray = [];

            selectedArray.push(input.id);
          } else {
            let selectedArray = [];
          }
        });
      });
    }
  }
};
handleRetailFilter(99, "Vyhledat značku");
handleRetailFilter(108, "Vyhledat model");
handleRetailFilter(63, "Vyhledat tloušťku");
handleRetailFilter(24, "Vyhledat počet článků");
handleRetailFilter(27, "Vyhledat rozteč");
handleRetailFilter(30, "Vyhledat šířku pásu");
document.addEventListener("ShoptetDOMPageContentLoaded", function () {
  handleRetailFilter(99, "Vyhledat značku");
  handleRetailFilter(108, "Vyhledat model");
  handleRetailFilter(63, "Vyhledat tloušťku");
  handleRetailFilter(24, "Vyhledat počet článků");
  handleRetailFilter(27, "Vyhledat rozteč");
  handleRetailFilter(30, "Vyhledat šířku pásu");
});
